import { Formik, Form } from "formik";
import { MedicalTravelModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import InputText from "../components/Form/InputText";
// import { BANKDEPOSIT } from "./RefundPreference";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function RefundInfo() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    // useEffect(() => {
    //     if (formData.refundpreference === BANKDEPOSIT) {
    //         setFormData((prev) => ({
    //             ...prev,
    //             valuecodeemail: "",
    //         }));
    //     }
    // }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<MedicalTravelModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/reseuppgifter");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}

                validationSchema={Yup.object().shape({
                    clearingnumber: Yup.string().required(
                        "Vänligen fyll i ditt clearingnummer"
                    ),
                    accountnumber: Yup.string().required(
                        "Vänligen fyll i ditt kontonummer"
                    ),
                })}

            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-between items-center">
                            <div className="flex justify-center h-15 md:h-auto mb-1">
                                <div className="w-full text-left md:hidden">
                                    <BackButton />
                                </div>
                            </div>

                            <div className="w-40 xs:w-52 md:w-full max-w-xs md:mb-4">
                                <Progressbar percentage={"25"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">
                                    Kontouppgifter för utbetalning
                                </h2>

                                <p>
                                    Ange clearing- och kontonummer för det konto som ersättningen ska betalas ut till.</p>
                                <p>Ange endast siffror, eventuella bindestreck, punkter eller mellanslag tas automatiskt bort.</p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="clearingnumber"
                                    label="Clearingnummer (Obligatoriskt)"
                                    type="number"
                                    numbersOnly
                                    autocomplete={"off"}
                                    moreinfo="Endast siffror"
                                />
                                <InputText
                                    name="accountnumber"
                                    label="Kontonummer (Obligatoriskt)"
                                    type="number"
                                    numbersOnly
                                    autocomplete={"off"}
                                    moreinfo="Endast siffror"
                                />

                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
